/**
 * Created by HYL.
 * 用户相关api
 */
import * as API from './'

export default {
  //登录
  login: params => {
	return API.POST('/api/login', params)
  },
  //登出
  logout: params => {
    return API.GET('/api/logout', params)
  },
//  tokenUser: params =>{
//    return API.GET('/api/user/currentUser',params)
//  },
  //修改个人信息
  changeProfile: params => {
    return API.postJsonRequest('/api/v1/users/profile', params)
  },

  //查询获取user列表(通过page分页)
  findList: params => {
    return API.POST('/api/user/list', params)
  },

  //增加用户
  addUser:params =>{
    return API.POST('/api/user/insert',params)
  },
  //修改用户
  editUser:params =>{
    return API.POST('/api/user/update',params)
  },
  //删除用户
  removeUser:params =>{
    return API.postJsonRequest('/api/user/delete',params)
  },
  findUserRoles:params=>{
    return API.GET('/api/user/role',params)
  },
  getDetial:params=>{
    return API.GET('/api/user/getDetail',params)
  },
  router: params =>{
    return API.GET('/api/router',params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_user.js